import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class WorkOrderReportProxyService {
  private readonly httpClient = inject(HttpClient);
  private readonly baseUrl = environment.proxyUrls.orderApi + '/api/v1/pdfwo';

  generatePdfReport(workOrderReference: string): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}/${workOrderReference}`, {
      responseType: 'blob',
    });
  }
}
